import Vue from 'vue'
import App from './App.vue'

import axios from 'axios' // Lecture 346

import router from './router'
import store from './store/store';

axios.defaults.baseURL = 'https://enginehire.io' // Lecture 346

// Lecture 349
// https://stackoverflow.com/questions/43051291/attach-authorization-header-for-all-axios-requests
axios.interceptors.request.use(config => {
  console.log('Request Interceptor', config)
  // console.log(store.state.userToken)
  // console.log(localStorage.getItem('token'))
  if (localStorage.getItem('token')) {
    config.headers['Authorization'] = 'Token ' + localStorage.getItem('token')
  }
  return config
})

new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js